export default __webpack_public_path__ + "139054b3b19a8def352ecda2e9f1ce7d.jpg";